export class Language {
    id: number = -1;
    fullName: string = '';
    shortName: string = '';
    published: boolean = false;
}